export const CHART_LAYOUT_CHILD_CHANGE_EVENT = 'chartLayoutChildChange'
